import { useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { StoreInterface } from '../../store/types';
import { AuthGrant } from '../../services/exports/Constants';
import useAuth from '../../hooks/global/useAuth';

const AuthGrantQueryParamKey = 'auth_grant';
const AuthTokenQueryParamKey = 'auth_token';

export default function NhasUserTokenAuthenticator() {
  const { company } = useSelector((store: StoreInterface) => store.initialData);
  const [searchParams, setSearchParams] = useSearchParams();
  const { isGuest, login } = useAuth();

  useEffect(() => {
    company?.id && isGuest && tryLogin();
  }, [company?.id]);

  async function tryLogin(): Promise<void> {
    if (
      !searchParams.has(AuthGrantQueryParamKey) ||
      !searchParams.has(AuthTokenQueryParamKey) ||
      searchParams.get(AuthGrantQueryParamKey) !== AuthGrant.NhasUserToken
    ) {
      return;
    }

    await login({
      grant: AuthGrant.NhasUserToken,
      company_id: company?.id,
      auth_token: searchParams.get(AuthTokenQueryParamKey),
    });

    searchParams.delete(AuthGrantQueryParamKey);
    searchParams.delete(AuthTokenQueryParamKey);
    setSearchParams(searchParams);
  }

  return null;
}
